'use client';

import type { CSSProperties } from 'styled-components';
import styled from 'styled-components';

import type { IconProps} from '@zoomit/icons';
import { Star } from '@zoomit/icons';
import { cn, Flex } from '@zoomit/primitives';
import { cssVar, theme } from '@zoomit/zoomit-ds';

import { isMobile } from '../../constants/media-query';

type Props = {
  rate: number;
  onSelect: (rate: number) => void;
  size: IconProps['size'];
  gap?: CSSProperties['gap'];
  justifyContent?: CSSProperties['justifyContent'];
};

const Rating = (props: Props) => {
  const { rate, onSelect, size, justifyContent = 'flex-start', gap = 0.2 } = props;

  return (
    <Root
      gap={gap}
      justifyContent={justifyContent}
      alignItems="center"
      flexWrap="nowrap"
      className={cn(isMobile && 'min-h-11')}
    >
      {Array.from({ length: 5 }).map((_, index) => (
        <button
          type="button"
          className="star flex cursor-pointer"
          key={index}
          onClick={() => onSelect(index)}
        >
          <Star size={size} fill={index < rate ? cssVar(theme.primary1) : cssVar(theme.grey3)} />
        </button>
      ))}
    </Root>
  );
};

export default Rating;

const Root = styled(Flex)`
  .star:hover,
  .star:has(~ .star:hover) {
    svg {
      fill: var(${theme.primary1});
    }
  }
`;
